// snackbarUtils.ts
import eventEmitter from "SnackBarEventEmitter";

export function handleExportError(
  error: unknown
): void {
  if (typeof error === "object" && error !== null && "response" in error) {
    const err = error as { response: { status: number } };

    switch (err.response.status) {
      case 503:
        eventEmitter.emit(
          "showSnackbar",
          "Export Excel: Service temporarily unavailable. Please try again later.",
          "info"
        );
        break;
      case 408:
        eventEmitter.emit(
          "showSnackbar",
          "Export Excel: Request Timeout",
          "info"
        );
        break;
      case 504:
        eventEmitter.emit(
          "showSnackbar",
          "Export Excel: Gateway Timeout",
          "info"
        );
        break;
      case 500:
        eventEmitter.emit(
          "showSnackbar",
          "Export Excel: Something Went Wrong",
          "info"
        );
        break;
      default:
        eventEmitter.emit(
          "showSnackbar",
          "Export Excel: Unexpected Error",
          "info"
        );
    }
  }
}